import React from 'react'

export function Title({ title }) {
  return (
    <div className="d-flex align-items-center">
      <h4 className="d-inline mr-2">{title}</h4>
    </div>
  )
}
